import AddComponent from './AddComponent'
export default AddComponent
